import { AreaTypeResource } from "./resources/area-type.resource";
import { AreaResource } from "./resources/area.resource";
import { LoginResource } from "./resources/login.resource"

export class ApiClient {
    static readonly area = new AreaResource();
    static readonly areaType = new AreaTypeResource();
    static readonly login = new LoginResource();
}